//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"AttentionColor",1,0],[0,"HandleActiveColor",1,0],[0,"HandleColor",1,0],[0,"HandleOrientxpressColor",1,0],[0,"HandlePreselectionColor",1,0],[0,"HandleSelectionColor",1,0],[0,"HiddenGeometryColor",1,0],[0,"MonochromeBackgroundColor",1,0],[0,"MonochromeDisplay",1,0],[0,"MonochromeForegroundColor",1,0],[0,"MonochromePreselectionColor",1,0],[0,"MonochromeSelectionColor",1,0],[0,"PreselectionColor",1,0],[0,"RandomColorDisplay",1,0],[0,"RandomColorDisplayOption",1,0],[0,"SelectionColor",1,0],[0,"ShowWidths",1,0]],[[[],"ShuffleRandomColor",{},0,0]],[]];
SPLM.Preferences.PartVisualizationColorSetting = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartVisualizationColorSetting";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartVisualizationColorSetting.RandomColorDisplayFor = Object.freeze({
    "Faces" : "Faces", "Bodies" : "Bodies"});

export default SPLM;